import { bulkInsert } from "./bulkInsert"
import { sqlRun } from "./ldb"
import { CloudToDeviceOfflineTableDrugProductMapBody } from "../redux/syncthunk/ZCloudToDevice"
import { err, ok, Result } from "neverthrow"
import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { selectAllText } from "./LdbBrowser"

export const selectAllDrugProductMapText = async (): Promise<string> => {
	return selectAllText('drugProductMap', ['ProductID', 'Icd10Code'])
}

export const ldbDrugProductMapBulkInsert = async (body: CloudToDeviceOfflineTableDrugProductMapBody): Promise<Result<void, FusionError>> => {
	const rDelete = await sqlRun('delete from drugProductMap')
	if(rDelete.isErr()) {
		return err(serializeFusionError('ldbDrugProductMapBulkInsert', rDelete.error))
	}
	let params = []
	for (let m of body.ProductMaps) {
		params.push(m.ProductID, m.Icd10Code)
	}
	const rInsert = await bulkInsert('drugProductMap', params, 2)
	if(rInsert.isErr()) {
		return err(serializeFusionError('ldbDrugProductMapBulkInsert', rInsert.error))
	}
	return ok()
}
